import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { DELIVERY_WAREHOUSES_GLOBAL_TAG } from '#shared/api/globalTags';
import { apiV1Request } from '#shared/api/requests';
import {
    OpenApiIsTwinsNeededMethod,
    type OpenApiIsTwinsNeededRequest,
    type OpenApiIsTwinsNeededResponseSuccess,
    OpenApiIsTwinsNeededUrl,
    OpenApiLinkWarehousesMethod,
    type OpenApiLinkWarehousesRequest,
    type OpenApiLinkWarehousesResponseSuccess,
    OpenApiLinkWarehousesUrl,
} from '#shared/api/schema';

const apiWarehouse = createApi({
    name: 'entities/warehouse/api/warehouse',
    tagTypes: [DELIVERY_WAREHOUSES_GLOBAL_TAG],
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            linkWarehouses: builder.mutation<OpenApiLinkWarehousesResponseSuccess, OpenApiLinkWarehousesRequest>({
                query: (payload) => {
                    return {
                        url: OpenApiLinkWarehousesUrl,
                        method: OpenApiLinkWarehousesMethod,
                        body: payload,
                    };
                },
                invalidatesTags: (_, error) => (error ? [] : [DELIVERY_WAREHOUSES_GLOBAL_TAG]),
            }),
            isTwinsNeeded: builder.query<OpenApiIsTwinsNeededResponseSuccess, OpenApiIsTwinsNeededRequest>({
                query: () => {
                    return {
                        url: OpenApiIsTwinsNeededUrl,
                        method: OpenApiIsTwinsNeededMethod,
                    };
                },
            }),
        };
    },
});

export const linkWarehouses = apiWarehouse.endpoints.linkWarehouses.mutate;
export const useIsTwinsWarehousesNeededQuery = apiWarehouse.useIsTwinsNeededQuery;
export const checkIsTwinsWarehousesNeededQuery = apiWarehouse.endpoints.isTwinsNeeded.query;
